module.exports = __webpack_public_path__ + "img/vertical-active.5e6c51c5.svg";